
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[postId]",
      function () {
        return require("private-next-pages/course/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[postId]"])
      });
    }
  